module.exports = __webpack_public_path__ + "01_face.f38dd1bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer1/01_face.png
// module id = y10w
// module chunks = 0